export enum ValidationMessages {
  REQUIRED = 'Kötelező mező',
  EMAIL = 'Érvényes email címet adjon meg',
  PASSWORD_MATCH = 'A két jelszónak meg kell egyeznie.'
}
